import PageHeader from "src/components/pageHeader";
import { CreateVouchersForm } from "../components/create-credit-vouchers/create-vouchers-form";

export const CreateCreditVouchers = () => {
  return (
    <div className="page_container">
      <PageHeader text="Create Credit Voucher" />
      <CreateVouchersForm />
    </div>
  );
};
